import { parseAdminDashboardAPIPayload, parseAdminDashboardAPIPayloadRevamp } from 'helpers/sf_admin_dashboard_helper';
import { ADMIN_DASHBOARD_API_CALL_TYPE, DASHBOARD_API_CALL_TYPE } from 'helpers/sf_constants';
import { parseDashboardAPIPayload } from 'helpers/sf_dashboard_helper';
import {
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_SUCCESS,
  GET_DASHBOARD_DATA_ERROR,

  LEADS_GET_ADMIN_DASHBOARD_DATA,
  LEADS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  LEADS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,

  RESET_DASHBOARD_ERROR,
  CALLS_GET_ADMIN_DASHBOARD_DATA,
  CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  GET_ADMIN_ANALYTICS_DATA,
  GET_ADMIN_ANALYTICS_DATA_SUCCESS,
  CLICKS_GET_ADMIN_DASHBOARD_DATA,
  CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  GET_ADMIN_ANALYTICS_DATA_ERROR,
  GET_ADMIN_ANALYTICS_PIXEL_STATS,
  GET_ADMIN_ANALYTICS_PIXEL_STATS_SUCCESS,
  GET_ADMIN_ANALYTICS_PIXEL_STATS_ERROR,
  RESET_ADMIN_ANALYTICS_PIXELS_DATA,
  GET_ADMIN_USER_SMART_VIEWS,
  GET_ADMIN_USER_SMART_VIEWS_SUCCESS,
  GET_ADMIN_USER_SMART_VIEWS_ERROR,
  CREATE_ADMIN_USER_SMART_VIEW,
  CREATE_ADMIN_USER_SMART_VIEW_SUCCESS,
  CREATE_ADMIN_USER_SMART_VIEW_ERROR,
  UPDATE_ADMIN_USER_SMART_VIEW,
  UPDATE_ADMIN_USER_SMART_VIEW_SUCCESS,
  UPDATE_ADMIN_USER_SMART_VIEW_ERROR,
  RESET_LAST_ADMIN_USER_SMART_VIEW_ACTION,
  GET_ADMIN_DASHBOARD_REVAMP_DATA,
  GET_ADMIN_DASHBOARD_REVAMP_DATA_SUCCESS,
  GET_ADMIN_DASHBOARD_REVAMP_DATA_ERROR,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_SUCCESS,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_ERROR,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA_SUCCESS,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA_ERROR,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR,
  DASHBOARD_REVAMPED,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_SUCCESS,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_ERROR,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_SUCCESS,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_ERROR,
  CLEAR_ADMIN_ANALYTICS_COMPARE_DATA
} from './actionTypes';
import { ADMIN_ANALYTICS_DATA_FIELDS } from 'helpers/sf_admin_dashboard_analytics_constants';

const INIT_STATE = {
  main_data: [],
  date_ranges: [],
  compare_to_main_data: [],

  //Clicks related
  clicks_main_data: [],
  clicks_date_ranges: [],
  clicks_compare_to_main_data: [],

  //Syndi Clicks related
  syndi_clicks_main_data: [],
  syndi_clicks_date_ranges: [],
  syndi_clicks_compare_to_main_data: [],

  //Quote funnels related
  quote_funnels_main_data: [],
  quote_funnels_date_ranges: [],
  quote_funnels_compare_to_main_data: [],

  quote_funnels_leads_calls_main_data: [],
  quote_funnels_leads_calls_date_ranges: [],
  quote_funnels_leads_calls_compare_to_main_data: [],

  //Leads related
  leads_main_data: [],
  leads_date_ranges: [],
  leads_compare_to_main_data: [],

  //Calls related
  calls_main_data: [],
  calls_date_ranges: [],
  calls_compare_to_main_data: [],

  // Admin analytics related
  clicks_admin_analytics_data: [],
  calls_admin_analytics_data: [],
  leads_admin_analytics_data: [],
  syndi_clicks_admin_analytics_data: [],
  quote_funnels_admin_analytics_data: [],

  clicks_admin_analytics_compare_to_data: [],
  calls_admin_analytics_compare_to_data: [],
  leads_admin_analytics_compare_to_data: [],
  syndi_clicks_admin_analytics_compare_to_data: [],
  quote_funnels_admin_analytics_compare_to_data: [],

  clicks_consistent_admin_analytics_data: [],
  calls_consistent_admin_analytics_data: [],
  leads_consistent_admin_analytics_data: [],
  syndi_clicks_consistent_admin_analytics_data: [],
  quote_funnels_consistent_admin_analytics_data: [],

  clicks_consistent_admin_analytics_compare_to_data: [],
  calls_consistent_admin_analytics_compare_to_data: [],
  leads_consistent_admin_analytics_compare_to_data: [],
  syndi_clicks_consistent_admin_analytics_compare_to_data: [],
  quote_funnels_consistent_admin_analytics_compare_to_data: [],

  clicks_admin_analytics_loading: false,
  calls_admin_analytics_loading: false,
  leads_admin_analytics_loading: false,
  syndi_clicks_admin_analytics_loading: false,
  quote_funnels_admin_analytics_loading: false,

  clicks_admin_analytics_compare_to_loading: false,
  calls_admin_analytics_compare_to_loading: false,
  leads_admin_analytics_compare_to_loading: false,
  syndi_clicks_admin_analytics_compare_to_loading: false,
  quote_funnels_admin_analytics_compare_to_loading: false,

  //Admin Dashboard Optimization
  dashboard_revamped: false,

  common_admin_analytics_data: [],

  common_admin_analytics_compare_to_data: [],

  common_consistent_admin_analytics_data: [],

  common_consistent_admin_analytics_compare_to_data: [],

  admin_analytics_loading: false,

  admin_analytics_compare_to_loading: false,

  //Admin Dashboard Optimization

  total_admin_analytics_data: [],
  consistent_total_admin_analytics_data: [],
  admin_analytics_error: null,
  metric_type: '',

  total_admin_analytics_compare_to_data: [],
  consistent_total_admin_analytics_compare_to_data: [],
  admin_analytics_compare_to_error: null,

  clicks_admin_analytics_pixel_stats: [],
  clicks_admin_analytics_pixel_stats_loading: false,

  clicks_admin_analytics_pixel_compare_to_stats: [],
  clicks_admin_analytics_pixel_compare_to_stats_loading: false,

  syndi_clicks_admin_analytics_pixel_stats: [],
  syndi_clicks_admin_analytics_pixel_stats_loading: false,

  syndi_clicks_admin_analytics_pixel_compare_to_stats: [],
  syndi_clicks_admin_analytics_pixel_compare_to_stats_loading: false,

  quote_funnels_admin_analytics_pixel_stats: [],
  quote_funnels_admin_analytics_pixel_stats_loading: false,

  quote_funnels_admin_analytics_pixel_compare_to_stats: [],
  quote_funnels_admin_analytics_pixel_compare_to_stats_loading: false,

  calls_admin_analytics_pixel_stats: [],
  calls_admin_analytics_pixel_stats_loading: false,

  calls_admin_analytics_pixel_compare_to_stats: [],
  calls_admin_analytics_pixel_compare_to_stats_loading: false,

  leads_admin_analytics_pixel_stats: [],
  leads_admin_analytics_pixel_stats_loading: false,

  leads_admin_analytics_pixel_compare_to_stats: [],
  leads_admin_analytics_pixel_compare_to_stats_loading: false,

  admin_analytics_pixel_stats: [],
  admin_analytics_pixel_stats_loading: false,
  admin_analytics_pixel_stats_error: null,

  admin_analytics_pixel_compare_to_stats: [],
  admin_analytics_pixel_compare_to_stats_loading: false,
  admin_analytics_pixel_compare_to_stats_error: null,

  compare_to_main_data_api: false,

  admin_user_smart_views: [],
  admin_user_sm_view_loading: false,
  create_admin_user_sm_view_loading: false,
  update_admin_user_sm_view_loading: false,
  admin_sm_view_error: null,
  last_user_smart_view_action: null,
  last_user_smart_view_id: null,

  admin_dashboard_revamp_data: [],
  admin_dashboard_revamp_data_loading: false,
  admin_dashboard_revamp_data_error: null,

  admin_dashboard_date_range_revamp_data: null,
  date_range_revamp_loading: false,
  date_range_revamp_error: null,

  admin_dashboard_compare_to_revamp_data: [],
  admin_dashboard_compare_to_revamp_loading: false,
  admin_dashboard_compare_to_revamp_error: null,

  loading: {
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA]: false,

    //For Click types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_DATE_RANGES]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_COMPARE_TO_MAIN_DATA]: false,

    //For Syndi Click types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_DATE_RANGES]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_COMPARE_TO_MAIN_DATA]: false,

    //For Quote Funnel types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_DATE_RANGES]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_COMPARE_TO_MAIN_DATA]: false,

    //For Quote Funnel leads calls types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_DATE_RANGES]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_COMPARE_TO_MAIN_DATA]: false,

    //For Lead types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_COMPARE_TO_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES]: false,

    //For Call types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_MAIN_DATA]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES]: false,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_COMPARE_TO_MAIN_DATA]: false,

  },
  error: {
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA]: null,

    //For Click types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_DATE_RANGES]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_COMPARE_TO_MAIN_DATA]: null,

    //For Syndi Click types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_DATE_RANGES]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_COMPARE_TO_MAIN_DATA]: null,

    //For Quote Funnel types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_DATE_RANGES]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_COMPARE_TO_MAIN_DATA]: null,

    //For Quote Funnel leads calls types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_DATE_RANGES]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_COMPARE_TO_MAIN_DATA]: null,

    //For Lead types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_COMPARE_TO_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES]: null,

    //For Call types
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_MAIN_DATA]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES]: null,
    [ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_COMPARE_TO_MAIN_DATA]: null,
  },
  last_query_time: null,

};
let time = 0;

const apiTypeToReducerField = (api_type) => {
  return api_type.replace('fetch_', '');
}

const getAdminAnalyticsFieldsForProduct = (prod_type) => {
  const product_type = (prod_type || '').replace(' ', '_')
  return {
    data_field: `${product_type}_admin_analytics_data`,
    consistent_data_field: `${product_type}_consistent_admin_analytics_data`,
    loading_field: `${product_type}_admin_analytics_loading`,
    pixel_data_field: `${product_type}_admin_analytics_pixel_stats`,
    pixel_loading_field: `${product_type}_admin_analytics_pixel_stats_loading`
  }
}

const getAdminAnalyticsCompareToFieldsForProduct = (prod_type) => {
  const product_type = (prod_type || '').replace(' ', '_')
  return {
    data_field: `${product_type}_admin_analytics_compare_to_data`,
    consistent_data_field: `${product_type}_consistent_admin_analytics_compare_to_data`,
    loading_field: `${product_type}_admin_analytics_compare_to_loading`,
    pixel_data_field: `${product_type}_admin_analytics_pixel_compare_to_stats`,
    pixel_loading_field: `${product_type}_admin_analytics_pixel_compare_to_stats_loading`
  }
}

const apiTypeToReducerFieldClicks = (api_type) => {
  return api_type.replace('fetch_clicks_', '');
}

const apiTypeToReducerFieldSyndiClicks = (api_type) => {
  return api_type.replace('fetch_syndi_clicks_', '');
}
const apiTypeToReducerFieldQuoteFunnels = (api_type) => {
  return api_type.replace('fetch_quote_funnels_', '');
}

const apiTypeToReducerFieldQuoteFunnelsLeadsCalls = (api_type) => {
  return api_type.replace('fetch_quote_funnels_leads_calls_', '');
}

const apiTypeToReducerFieldLeads = (api_type) => {
  return api_type.replace('fetch_leads_', '');
}

const apiTypeToReducerFieldCalls = (api_type) => {
  return api_type.replace('fetch_calls_', '');
}

const get_consistent_analytics_data = (analytics_data, dashboardRevamped) => {
  const admin_dashboard_key_map = {
    total_inventory: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_INVENTORY,
    total_opportunities: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_OPPORTUNITIES,
    total_searches: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SEARCHES,
    total_selected: 'total_selected', // no need to show on UI
    total_won: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SELECTED,
    total_leads: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_ACCEPTED,
    total_cost: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_COST,
    avg_bid: ADMIN_ANALYTICS_DATA_FIELDS.AVG_BID,
    avg_cpl: ADMIN_ANALYTICS_DATA_FIELDS.COST_PER,
    avg_cpc: ADMIN_ANALYTICS_DATA_FIELDS.COST_PER,
    target_rate: ADMIN_ANALYTICS_DATA_FIELDS.TARGET_RATE,
    bid_rate: ADMIN_ANALYTICS_DATA_FIELDS.BID_RATE,
    epw: ADMIN_ANALYTICS_DATA_FIELDS.EPW,
    win_rate: ADMIN_ANALYTICS_DATA_FIELDS.WIN_RATE,
    success_rate: ADMIN_ANALYTICS_DATA_FIELDS.SUCCESS_RATE,
    total_duration: 'total_duration', // no need to show on UI
    total_clicks: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_ACCEPTED,
    total_calls: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SELECTED,
    billable_calls: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_ACCEPTED,
    impressions: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SELECTED,
    total_upstream_bid: ADMIN_ANALYTICS_DATA_FIELDS.UPSTREAM_BID,
    avg_upstream_bid: ADMIN_ANALYTICS_DATA_FIELDS.AVG_UPSTREAM_BID,
  };

  const key_map = {
    lead_analytic_total_inventory: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_INVENTORY,
    lead_analytic_total_opportunities: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_OPPORTUNITIES,
    lead_analytic_total_searches: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SEARCHES,
    lead_analytic_total_selected: 'lead_analytic_total_selected', // no need to show on UI
    lead_analytic_total_won: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SELECTED,
    lead_analytic_total_leads: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_ACCEPTED,
    lead_analytic_total_cost: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_COST,
    lead_analytic_avg_bid: ADMIN_ANALYTICS_DATA_FIELDS.AVG_BID,
    lead_analytic_avg_cpl: ADMIN_ANALYTICS_DATA_FIELDS.COST_PER,
    lead_analytic_target_rate: ADMIN_ANALYTICS_DATA_FIELDS.TARGET_RATE,
    lead_analytic_bid_rate: ADMIN_ANALYTICS_DATA_FIELDS.BID_RATE,
    lead_analytic_epw: ADMIN_ANALYTICS_DATA_FIELDS.EPW,
    lead_analytic_win_rate: ADMIN_ANALYTICS_DATA_FIELDS.WIN_RATE,
    lead_analytic_success_rate: ADMIN_ANALYTICS_DATA_FIELDS.SUCCESS_RATE,
    call_analytic_total_inventory: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_INVENTORY,
    call_analytic_total_opportunities: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_OPPORTUNITIES,
    call_analytic_total_searches: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SEARCHES,
    call_analytic_total_calls: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SELECTED,
    call_analytic_billable_calls: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_ACCEPTED,
    call_analytic_total_cost: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_COST,
    call_analytic_total_duration: 'call_analytic_total_duration', // no need to show on UI
    call_analytic_avg_bid: ADMIN_ANALYTICS_DATA_FIELDS.AVG_BID,
    call_analytic_avg_cpc: ADMIN_ANALYTICS_DATA_FIELDS.COST_PER,
    call_analytic_target_rate: ADMIN_ANALYTICS_DATA_FIELDS.TARGET_RATE,
    call_analytic_bid_rate: ADMIN_ANALYTICS_DATA_FIELDS.BID_RATE,
    call_analytic_epw: ADMIN_ANALYTICS_DATA_FIELDS.EPW,
    call_analytic_win_rate: ADMIN_ANALYTICS_DATA_FIELDS.WIN_RATE,
    call_analytic_success_rate: ADMIN_ANALYTICS_DATA_FIELDS.SUCCESS_RATE,
    click_analytic_total_inventory: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_INVENTORY,
    click_analytic_total_opportunities: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_OPPORTUNITIES,
    click_analytic_total_searches: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SEARCHES,
    click_analytic_impressions: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_SELECTED,
    click_analytic_total_clicks: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_ACCEPTED,
    click_analytic_total_cost: ADMIN_ANALYTICS_DATA_FIELDS.TOTAL_COST,
    click_analytic_total_upstream_bid: ADMIN_ANALYTICS_DATA_FIELDS.UPSTREAM_BID,
    click_analytic_avg_upstream_bid: ADMIN_ANALYTICS_DATA_FIELDS.AVG_UPSTREAM_BID,
    click_analytic_avg_bid: ADMIN_ANALYTICS_DATA_FIELDS.AVG_BID,
    click_analytic_avg_cpc: ADMIN_ANALYTICS_DATA_FIELDS.COST_PER,
    click_analytic_target_rate: ADMIN_ANALYTICS_DATA_FIELDS.TARGET_RATE,
    click_analytic_bid_rate: ADMIN_ANALYTICS_DATA_FIELDS.BID_RATE,
    click_analytic_epw: ADMIN_ANALYTICS_DATA_FIELDS.EPW,
    click_analytic_win_rate: ADMIN_ANALYTICS_DATA_FIELDS.WIN_RATE,
    click_analytic_success_rate: ADMIN_ANALYTICS_DATA_FIELDS.SUCCESS_RATE,
  };

  const selected_key_map = dashboardRevamped ? admin_dashboard_key_map : key_map;


  return analytics_data.map(ana => {
    let ret_obj = {}
    for (let key of Object.keys(ana)) {
      if (selected_key_map[key]) {
        ret_obj[selected_key_map[key]] = ana[key];
      } else {
        ret_obj[key] = ana[key];
      }
    }

    return ret_obj;
  })
}

const AdminDashboard = (state = INIT_STATE, action) => {
  function clearQueryTime() {
    state = {
      ...state,
      last_query_time: null,
    };
  }
  switch (action.type) {
    case GET_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,
        main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA ? [] : state.main_data,
        date_ranges: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES ? [] : state.date_ranges,
        compare_to_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA ? [] : state.compare_to_main_data,


        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case GET_DASHBOARD_DATA_SUCCESS:
      // setTimeout(clearQueryTime, 2000);
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseDashboardAPIPayload(action.payload[apiTypeToReducerField(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case GET_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    //Clicks
    case CLICKS_GET_ADMIN_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        clicks_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_MAIN_DATA ? [] : state.clicks_main_data,
        clicks_date_ranges: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_DATE_RANGES ? [] : state.clicks_date_ranges,
        clicks_compare_to_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CLICKS_COMPARE_TO_MAIN_DATA ? [] : state.clicks_compare_to_main_data,

        metric_type: action.payload.metric_type,
        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseAdminDashboardAPIPayload(action.payload[apiTypeToReducerFieldClicks(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    case SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        syndi_clicks_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_MAIN_DATA ? [] : state.syndi_clicks_main_data,
        syndi_clicks_date_ranges: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_DATE_RANGES ? [] : state.syndi_clicks_date_ranges,
        syndi_clicks_compare_to_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_SYNDI_CLICKS_COMPARE_TO_MAIN_DATA ? [] : state.syndi_clicks_compare_to_main_data,

        metric_type: action.payload.metric_type,
        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseAdminDashboardAPIPayload(action.payload[apiTypeToReducerFieldSyndiClicks(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    case QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        quote_funnels_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_MAIN_DATA ? [] : state.quote_funnels_main_data,
        quote_funnels_date_ranges: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_DATE_RANGES ? [] : state.quote_funnels_date_ranges,
        quote_funnels_compare_to_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_COMPARE_TO_MAIN_DATA ? [] : state.quote_funnels_compare_to_main_data,

        metric_type: action.payload.metric_type,
        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseAdminDashboardAPIPayload(action.payload[apiTypeToReducerFieldQuoteFunnels(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    case QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        quote_funnels_leads_calls_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_MAIN_DATA ? [] : state.quote_funnels_leads_calls_main_data,
        quote_funnels_leads_calls_date_ranges: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_DATE_RANGES ? [] : state.quote_funnels_leads_calls_date_ranges,
        quote_funnels_leads_calls_compare_to_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_QUOTE_FUNNELS_LEADS_CALLS_COMPARE_TO_MAIN_DATA ? [] : state.quote_funnels_leads_calls_compare_to_main_data,

        metric_type: action.payload.metric_type,
        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseAdminDashboardAPIPayload(action.payload[apiTypeToReducerFieldQuoteFunnelsLeadsCalls(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    //Leads
    case LEADS_GET_ADMIN_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        leads_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_MAIN_DATA ? [] : state.leads_main_data,
        leads_date_ranges: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_DATE_RANGES ? [] : state.leads_date_ranges,
        leads_compare_to_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_LEADS_COMPARE_TO_MAIN_DATA ? [] : state.leads_compare_to_main_data,

        metric_type: action.payload.metric_type,
        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case LEADS_GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseAdminDashboardAPIPayload(action.payload[apiTypeToReducerFieldLeads(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case LEADS_GET_ADMIN_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };


    //Calls
    case CALLS_GET_ADMIN_DASHBOARD_DATA:
      time = performance.now();
      return {
        ...state,
        error: null,

        calls_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_MAIN_DATA ? [] : state.calls_main_data,
        calls_date_ranges: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_DATE_RANGES ? [] : state.calls_date_ranges,
        calls_compare_to_main_data: action.api_type === ADMIN_DASHBOARD_API_CALL_TYPE.FETCH_CALLS_COMPARE_TO_MAIN_DATA ? [] : state.calls_compare_to_main_data,

        loading: {
          ...state.loading, [action.api_type]: true
        },
        last_query_time: null,
      };

    case CALLS_GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      // setTimeout(clearQueryTime, 2000);
      time = (performance.now() - time) / 1000;
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: parseAdminDashboardAPIPayload(action.payload[apiTypeToReducerFieldCalls(action.api_type)], action.api_type),
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
        last_query_time: time.toFixed(2),

      };

    case CALLS_GET_ADMIN_DASHBOARD_DATA_ERROR:
      return {
        ...state,
        // TODO: Error handling
        error: action.payload,
        loading: false,
      };

    case RESET_DASHBOARD_ERROR:
      return {
        ...state,
        error: null,
      };

    case GET_ADMIN_ANALYTICS_DATA:
      {
        const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.data_field]: [],
          [adminAnalyticsFields.consistent_data_field]: [],
          total_admin_analytics_data: [],
          consistent_total_admin_analytics_data: [],
          [adminAnalyticsFields.loading_field]: true,
          admin_analytics_error: null,
          common_consistent_admin_analytics_data: [],
          common_consistent_admin_analytics_compare_to_data: [],
        }
      }


    case GET_ADMIN_ANALYTICS_DATA_SUCCESS:
      {
        const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(action.product_type)
        // Taking first 1000 entries only
        // This is necessary for when we're trying to group by something like zipcodes
        const admin_analytics_data_sliced = action.payload.admin_analytics.slice(0, 1000);
        return {
          ...state,
          [adminAnalyticsFields.data_field]: action.payload.admin_analytics,
          [adminAnalyticsFields.consistent_data_field]: get_consistent_analytics_data(admin_analytics_data_sliced, false),
          total_admin_analytics_data: admin_analytics_data_sliced,
          consistent_total_admin_analytics_data: get_consistent_analytics_data(action.payload.total_admin_analytics, false),
          [adminAnalyticsFields.loading_field]: false,
          admin_analytics_error: null
        }
      }

    case GET_ADMIN_ANALYTICS_DATA_ERROR:
      {
        const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(action.product_type)
        {
          return {
            ...state,
            [adminAnalyticsFields.loading_field]: false,
            admin_analytics_error: action.payload
          }
        }
      }

    case GET_ADMIN_ANALYTICS_COMPARE_TO_DATA:
      {
        const adminAnalyticsFields = getAdminAnalyticsCompareToFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.data_field]: [],
          [adminAnalyticsFields.consistent_data_field]: [],
          total_admin_analytics_compare_to_data: [],
          consistent_total_admin_analytics_compare_to_data: [],
          [adminAnalyticsFields.loading_field]: true,
          admin_analytics_compare_to_error: null
        }
      }


    case GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS:
      {
        const adminAnalyticsFields = getAdminAnalyticsCompareToFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.data_field]: action.payload.admin_analytics,
          [adminAnalyticsFields.consistent_data_field]: get_consistent_analytics_data(action.payload.admin_analytics, false),
          total_admin_analytics_compare_to_data: action.payload.total_admin_analytics,
          consistent_total_admin_analytics_compare_to_data: get_consistent_analytics_data(action.payload.total_admin_analytics, false),
          [adminAnalyticsFields.loading_field]: false,
          admin_analytics_compare_to_error: null
        }
      }

    case GET_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR:
      {
        const adminAnalyticsFields = getAdminAnalyticsCompareToFieldsForProduct(action.product_type)
        {
          return {
            ...state,
            [adminAnalyticsFields.loading_field]: false,
            admin_analytics_compare_to_error: action.payload
          }
        }
      }
    case DASHBOARD_REVAMPED:
      return {
        ...state,
        dashboard_revamped: true
      }
    case GET_REVAMPED_ADMIN_ANALYTICS_DATA:
      return {
        ...state,
        common_admin_analytics_data: [],
        common_consistent_admin_analytics_data: [],
        total_admin_analytics_data: [],
        consistent_total_admin_analytics_data: [],
        admin_analytics_loading: true,
        admin_analytics_error: null
      }


    case GET_REVAMPED_ADMIN_ANALYTICS_DATA_SUCCESS:
      const admin_analytics_data_sliced = action.payload.admin_analytics.slice(0, 1000);
      return {
        ...state,
        common_admin_analytics_data: action.payload.admin_analytics,
        common_consistent_admin_analytics_data: get_consistent_analytics_data(admin_analytics_data_sliced, true),
        total_admin_analytics_data: admin_analytics_data_sliced,
        consistent_total_admin_analytics_data: get_consistent_analytics_data(action.payload.total_admin_analytics, true),
        admin_analytics_loading: false,
        admin_analytics_error: null
      }

    case GET_REVAMPED_ADMIN_ANALYTICS_DATA_ERROR:
      return {
        ...state,
        admin_analytics_loading: false,
        admin_analytics_error: action.payload
      }

    case GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA:
      return {
        ...state,
        common_admin_analytics_compare_to_data: [],
        common_consistent_admin_analytics_compare_to_data: [],
        total_admin_analytics_compare_to_data: [],
        consistent_total_admin_analytics_compare_to_data: [],
        admin_analytics_compare_to_loading: true,
        admin_analytics_compare_to_error: null,
        compare_to_main_data_api: true
      }


    case GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_SUCCESS:
      return {
        ...state,
        common_admin_analytics_compare_to_data: action.payload.admin_analytics,
        common_consistent_admin_analytics_compare_to_data: get_consistent_analytics_data(action.payload.admin_analytics, true),
        total_admin_analytics_compare_to_data: action.payload.total_admin_analytics,
        consistent_total_admin_analytics_compare_to_data: get_consistent_analytics_data(action.payload.total_admin_analytics, true),
        admin_analytics_compare_to_loading: false,
        admin_analytics_compare_to_error: null
      }

    case GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA_ERROR:
      return {
        ...state,
        admin_analytics_compare_to_loading: false,
        admin_analytics_compare_to_error: action.payload
      }

    case GET_ADMIN_ANALYTICS_PIXEL_STATS:
      {
        const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.pixel_data_field]: [],
          [adminAnalyticsFields.pixel_loading_field]: true,
          admin_analytics_pixel_stats_error: null
        }
      }


    case GET_ADMIN_ANALYTICS_PIXEL_STATS_SUCCESS:
      {
        const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.pixel_data_field]: action.payload,
          [adminAnalyticsFields.pixel_loading_field]: false,
          admin_analytics_pixel_stats_error: null
        }
      }

    case GET_ADMIN_ANALYTICS_PIXEL_STATS_ERROR:
      {
        const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(action.product_type)
        return {
          ...state,
          admin_analytics_pixel_stats_error: action.payload,
          [adminAnalyticsFields.pixel_loading_field]: false,
        }
      }

    case GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS:
      {
        const adminAnalyticsFields = getAdminAnalyticsCompareToFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.pixel_data_field]: [],
          [adminAnalyticsFields.pixel_loading_field]: true,
          admin_analytics_pixel_compare_to_stats_error: null,
          compare_to_main_data_api: true
        }
      }


    case GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_SUCCESS:
      {
        const adminAnalyticsFields = getAdminAnalyticsCompareToFieldsForProduct(action.product_type)
        return {
          ...state,
          [adminAnalyticsFields.pixel_data_field]: action.payload,
          [adminAnalyticsFields.pixel_loading_field]: false,
          admin_analytics_pixel_compare_to_stats_error: null
        }
      }

    case GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS_ERROR:
      {
        const adminAnalyticsFields = getAdminAnalyticsCompareToFieldsForProduct(action.product_type)
        return {
          ...state,
          admin_analytics_pixel_compare_to_stats_error: action.payload,
          [adminAnalyticsFields.pixel_loading_field]: false,
        }
      }

    case RESET_ADMIN_ANALYTICS_PIXELS_DATA:
      {
        let new_state_obj = {}
        for (const product_type of action.payload.product_types) {
          const adminAnalyticsFields = getAdminAnalyticsFieldsForProduct(product_type)
          const adminAnalyticsCompareToFields = getAdminAnalyticsCompareToFieldsForProduct(product_type)
          new_state_obj[adminAnalyticsFields.data_field] = []
          new_state_obj[adminAnalyticsFields.consistent_data_field] = []
          new_state_obj[adminAnalyticsFields.pixel_data_field] = []
          new_state_obj[adminAnalyticsCompareToFields.data_field] = []
          new_state_obj[adminAnalyticsCompareToFields.consistent_data_field] = []
          new_state_obj[adminAnalyticsCompareToFields.pixel_data_field] = []
        }

        return {
          ...state,
          ...new_state_obj,
          compare_to_main_data_api: false
        }
      }
    case GET_ADMIN_USER_SMART_VIEWS:
      return {
        ...state,
        admin_user_sm_view_loading: true
      }
    case GET_ADMIN_USER_SMART_VIEWS_SUCCESS:
      return {
        ...state,
        admin_user_sm_view_loading: false,
        admin_user_smart_views: action.payload
      }
    case GET_ADMIN_USER_SMART_VIEWS_ERROR:
      return {
        ...state,
        admin_user_sm_view_loading: false,
        admin_sm_view_error: action.payload
      }
    case CREATE_ADMIN_USER_SMART_VIEW:
      return {
        ...state,
        admin_user_sm_View_loading: true,
        create_admin_user_sm_view_loading: true
      }
    case CREATE_ADMIN_USER_SMART_VIEW_SUCCESS:
      return {
        ...state,
        admin_user_sm_View_loading: false,
        admin_user_smart_views: [...state.admin_user_smart_views, ...action.payload],
        create_admin_user_sm_view_loading: false,
        last_user_smart_view_action: action.payload?.[0]?.id ? action.type : state.last_user_smart_view_action,
        last_user_smart_view_id: action.payload?.[0]?.id
      }
    case CREATE_ADMIN_USER_SMART_VIEW_ERROR:
      return {
        ...state,
        admin_user_sm_View_loading: false,
        create_admin_user_sm_view_loading: false,
        admin_sm_view_error: action.payload
      }
    case UPDATE_ADMIN_USER_SMART_VIEW:
      return {
        ...state,
        admin_user_sm_view_loading: true,
        update_admin_user_sm_view_loading: true
      }
    case UPDATE_ADMIN_USER_SMART_VIEW_SUCCESS:
      return {
        ...state,
        admin_user_sm_View_loading: false,
        update_admin_user_sm_view_loading: false,
        admin_user_smart_views: state.admin_user_smart_views.map(user_sm_view => {
          const same_view_in_payload = action.payload.find(payload_user_sm_view => payload_user_sm_view?.id === user_sm_view?.id);
          if (same_view_in_payload) {
            return same_view_in_payload;
          }
          return user_sm_view;
        }),
        last_user_smart_view_action: action.payload?.[0]?.id ? action.type : state.last_user_smart_view_action,
        last_user_smart_view_id: action.payload?.[0]?.id
      }
    case UPDATE_ADMIN_USER_SMART_VIEW_ERROR:
      return {
        ...state,
        admin_user_sm_View_loading: false,
        update_admin_user_sm_view_loading: false,
        admin_sm_view_error: action.payload
      }
    case RESET_LAST_ADMIN_USER_SMART_VIEW_ACTION:
      return {
        ...state,
        last_user_smart_view_id: null,
        last_user_smart_view_action: null
      }

    case GET_ADMIN_DASHBOARD_REVAMP_DATA:
      return {
        ...state,
        admin_dashboard_revamp_loading: true
      } 
    case GET_ADMIN_DASHBOARD_REVAMP_DATA_SUCCESS:
      return {
        ...state,
        admin_dashboard_revamp_loading: false,
        admin_dashboard_revamp_data: parseAdminDashboardAPIPayloadRevamp(action.payload)
      }

    case GET_ADMIN_DASHBOARD_REVAMP_DATA_ERROR:
      return {
        ...state,
        admin_dashboard_revamp_loading: false,
        admin_dashboard_revamp_error: action.payload
      }

    case GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP:
      return {
        ...state,
        date_range_revamp_loading: true,
        date_range_revamp_error: null
      };
    case GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_SUCCESS:
      return {
        ...state,
        admin_dashboard_date_range_revamp_data: parseAdminDashboardAPIPayloadRevamp(action.payload),
        date_range_revamp_loading: false
      };
    case GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP_ERROR:
      return {
        ...state,
        date_range_revamp_error: action.payload,
        date_range_revamp_loading: false
      };

    case GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP:
      return {
        ...state,
        admin_dashboard_compare_to_revamp_loading: true
      };

    case GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_SUCCESS:
      return {
        ...state,
        admin_dashboard_compare_to_revamp_loading: false,
        admin_dashboard_compare_to_revamp_data: parseAdminDashboardAPIPayloadRevamp(action.payload)
      };  

    case GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP_ERROR:
      return {
        ...state,
        admin_dashboard_compare_to_revamp_loading: false,
        admin_dashboard_compare_to_revamp_error: action.payload
      };

    case CLEAR_ADMIN_ANALYTICS_COMPARE_DATA:
      return {
        ...state,
        common_consistent_admin_analytics_compare_to_data: [],
        syndi_clicks_consistent_admin_analytics_compare_to_data: [],
        quote_funnels_consistent_admin_analytics_compare_to_data: [],
        clicks_admin_analytics_pixel_compare_to_stats: [],
        calls_admin_analytics_pixel_compare_to_stats: [],
        leads_admin_analytics_pixel_compare_to_stats: [],
        syndi_clicks_admin_analytics_pixel_compare_to_stats: [],
        quote_funnels_admin_analytics_pixel_compare_to_stats: [],
        compare_to_main_data_api: false
      };
      
      
      

    default:
      return state;
  }
};

export default AdminDashboard;